"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const config_1 = require("../config");
const vector_1 = require("../core/vector");
class Area {
    constructor(grid) {
        this.grid = grid;
        const firstRow = grid[0];
        const firstTile = grid[0][0];
        this.size = new vector_1.default(firstRow.length, grid.length);
        this.offset = firstTile.location;
    }
    get(x, y) {
        const entry = this.grid[y];
        return entry ? entry[x] : null;
    }
    getRow(y) {
        if (y < 0)
            y = this.size.y + y;
        return this.grid[y] || null;
    }
    getCol(x) {
        if (x < 0)
            x = this.size.x + x;
        if (x < 0 || x >= this.size.x)
            return null;
        return this.grid.map(row => row[x]);
    }
    getRange(point, size) {
        const result = [];
        for (let j = 0; j < size.y; j++) {
            result[j] = [];
            const row = this.grid[j + point.y];
            if (!row)
                continue;
            for (let i = 0; i < size.x; i++) {
                const tile = row[i + point.x];
                if (!tile)
                    break;
                result[j][i] = tile;
            }
        }
        return new Area(result);
    }
    getNeighbor(tile, direction) {
        const index = vector_1.default.diff(tile.location, this.offset);
        switch (direction) {
            // case Side.UP:
            // case Side.DOWN:
            case config_1.Side.NORTH:
            case config_1.Side.SOUTH:
                return this.get(index.x, index.y + (direction === config_1.Side.NORTH ? -1 : +1));
            case config_1.Side.EAST:
            case config_1.Side.WEST:
                return this.get(index.x + (direction === config_1.Side.WEST ? -1 : +1), index.y);
        }
    }
    getNeighbors(tile) {
        const index = vector_1.default.diff(tile.location, this.offset);
        const result = [];
        for (let i = -1; i <= 1; i++) {
            for (let j = -1; j <= 1; j++) {
                if (i === 0 && j === 0)
                    continue;
                const cell = this.get(index.x + j, index.y + i);
                if (cell)
                    result.push(cell);
            }
        }
        return result;
    }
    forEach(iterator) {
        this.grid.forEach((row, i) => row.forEach((tile, j) => iterator(tile, j, i, this)));
    }
}
exports.Area = Area;



//////////////////
// WEBPACK FOOTER
// ./src/world/area.ts
// module id = 12
// module chunks = 0